@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
<div class="content">
  @if (isLoaded()) {
    <div class="configuration">
      <app-unit-information (tagInformationUpdated)="updateTaggingDetails($event)" [line]="entityLine()"
        [isOem]="isOem()" [tags]="taggingDetails()" [invalidEntities]="invalidEntities()"
        [engineKey]="getEngineKey()" (valueChanged)="validateUnit()"
        (quantityChanged)="quantityChanged()" [selectionEntities]="selectionEntities()">
      </app-unit-information>
      <app-belt-drive-system-inputs (valueChanged)="validateUnit()" [selectionEntities]="selectionEntities()"
        [invalidEntities]="invalidEntities()" [engineKey]="getEngineKey()"
        (unitTypeChanged)="unitTypeChanged()" (systemTypeChanged)="systemTypeChanged()">
      </app-belt-drive-system-inputs>
      <app-indoor-air-quality (valueChanged)="validateUnit()" [selectionEntities]="selectionEntities()"
        [invalidEntities]="invalidEntities()" [engineKey]="getEngineKey()">
      </app-indoor-air-quality>
      <app-belt-drive-mechanical-connections [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" [imagePrefix]="getImagePrefix()"
        (valueChanged)="validateUnit()">
      </app-belt-drive-mechanical-connections>
      <app-belt-drive-controls [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" (valueChanged)="validateUnit()">
      </app-belt-drive-controls>
      <app-belt-drive-coil-options [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" (valueChanged)="validateUnit()">
      </app-belt-drive-coil-options>
      <app-belt-drive-drive-assembly [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" (valueChanged)="validateUnit()">
      </app-belt-drive-drive-assembly>
      <app-belt-drive-cabinet-features [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" (valueChanged)="validateUnit()">
      </app-belt-drive-cabinet-features>
    </div>
  }
  <div class="prices">
    <app-skus-and-prices [modelImagePath]="unitImagePath()" [messages]="messages()" [skus]="skus()" [sfrEntries]="sfrEntries()"
      [entityLeadTime]="entityLeadTime"
      [configurationLeadTime]="configurationLeadTime()" (sfrFlagChanged)="sfrFlagChanged()">
    </app-skus-and-prices>
  </div>
</div>
